<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Stock/ Stock out wait
           
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7 || roleid == 78">
        
            <b-tab-item label="ເຄື່ອງໃນສາງ (ສຳລັບເອົາອອກສາງ)">
              <div class="columns scrollme" >
                <div class="column" >
                  <b-field>
                    <div class="columns" style=" display: flex">
                      
                      <div class="column">
                        

                        <div class="columns">
                          <div class="column">
                            <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ເຄື່ອງທີ່ມີໃນສາງ ( ແຍກຕາມ Lot )</div>    
                          </div>
                        
                          <div class="column" style="padding-right:50px;"> 
                            <b-field>
                              <Multiselect
                                placeholder="ເລືອກສິນຄ້າ"  
                                v-model.trim="selectedRemainProduct"
                                label="NAME"
                                track-by="ID"
                                :options="stockRemainProductList"
                              >
                              </Multiselect>
                            </b-field>
                          </div>

                          <div class="column" style="padding-right:50px;"> 
                            <b-field grouped>
                              <b-field>
                                <Multiselect
                                  placeholder="ສະຖານະ"  
                                  v-model.trim="selectedRemainProductStatus"
                                  label="NAME"
                                  track-by="ID"
                                  :options="stockStatusList"
                                >
                                </Multiselect>
                              </b-field>
                              
                              <b-field>
                                <b-button
                                  class="btn-group-margin"
                                  type="is-info"
                                  @click="onSelectedStockRemainProduct(0)"
                                  >ເບິ່ງຂໍ້ມູນ
                                </b-button>
                              </b-field>
                            </b-field>
                              
                          </div>

                          <div class="column" style="padding-right:50px;"> 
                            <b-field grouped>
                              <b-field>  
                                <b-button
                                  class="btn-group-margin"
                                  type="is-success"
                                  @click="onSelectedStockRemainProduct(1)"
                                  >ເບິ່ງລາຍການ ລໍຖ້າອະນຸມັດ
                                </b-button>
                              </b-field>
                            </b-field>
                              
                          </div>


                          
                        </div>
                        
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">Lot</th>

                              <th class="has-text-left " width="08%">
                                ວັນທີຊື້ເຂົ້າສາງ
                              </th>
        
                              <th class="has-text-left " width="30%">
                                ສິນຄ້າ
                              </th>
                          
                              <th class="has-text-right " width="8%">
                                ຈຳນວນ<br>ຊື້ເຂົ້າ
                              </th>  
                              <th class="has-text-right " width="8%">
                                ຂາຍອອກ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ຖິ້ມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ<br>ລວມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຍັງເຫຼືອ
                              </th>
                              <th class="has-text-centered " width="10%">
                                ຈັດການ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data) in productInStock"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ data.ID }}<br> 
                                <span style="background-color: red; color: white;">{{ data.WAITID }}</span>
                            
                              </td>

                              <td>
                                {{data.TXDATE}}
                              </td>
                              <td class="has-text-left">
                                {{  data.PRODUCTNAME }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.STOCKIN | formatNumberLocal }}
                              </td>
                
                              
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                              </td>
                  
                              <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                {{ data.ALLBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.LOTREMAIN | formatNumberLocal }}
                              </td> 

                              <td class="has-text-right">
                                <b-button
                                  class="btn-group-margin"
                                  type="is-info"
                                  size="is-small"
                                  @click="getProductInStockDetail(data)"
                                  >ເອົາເຄື່ອງອອກ
                                </b-button>
                              </td> 
                                                            
                            </tr>
                          </tbody>
                          
                        </table>
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="ຕິດຕາມເຄື່ອງອອກສາງ">
              <div class="columns scrollme">
                <div class="column" v-if="isActiveStockOutForm">
                  <b-field>
                    <div class="columns" style=" display: flex">
                      <div class="column column-35" style="padding-right: 100px;">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຟອມເອົາເຄື່ອງອອກສາງ</div>    
            
                        
                        <div class="columns">
                          <div class="column">  
                            ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockOutDate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                        </div>
                        

                        <div class="columns">
                          <div class="column">
                            ຂາຍອອກ 
                            <b-input
                              v-model.trim="selectedStockProductSell" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            ເສຍຫາຍບາງສ່ວນ-ຂາຍໃຫ້ຫ້ອງການ
                            <b-input
                              v-model.trim="selectedStockProductOfficeSell" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            ເສຍຫາຍ-ຖິ້ມ
                            <b-input
                              v-model.trim="selectedStockProductBroken" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"  
                              @click="saveStockOutWait()"
                              >ບັນທຶກ
                            </b-button> 
                          </div>
                        </div>

                      </div>
                      <div class="column column-65">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ປະຫວັດ ການເບີກເຄື່ອງອອກສາງ</div>    
                        <div class="columns" style="color: red;">
                          {{selectedProductOutData.ID}} - {{selectedProductOutData.PRODUCTNAME}}
                        </div>
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">
                                # 
                                
                              </th>

                              <th class="has-text-left " width="10%">
                                ວັນທີ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເຄື່ອງໃນສາງ
                              </th>
                              <th class="has-text-right " width="10%">
                                ມູນຄ່າ<br>ຕັ້ງຕົ້ນ
                              </th>
                              <th class="has-text-right " width="8%">
                              ຂາຍອອກ
                              </th>  
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ  <br>
                                ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ 
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ລວມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ<br>ສະສົມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຈຳນວນ<br>ຍັງເຫຼືອ
                              </th>
                              <th class="has-text-right " width="10%">
                                ລາຄາຂາຍ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="10%">
                                ມູນຄ່າ<br>ຍັງເຫຼືອ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productInStockUsage"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}
                                
                              </td>

                              <td class="has-text-left">
                                {{data.TXDATE}}
                              </td>
                              <td class="has-text-right">
                                {{  data.INSTOCK | formatNumberLocal }}
                              </td>            
                              <td class="has-text-right">
                                {{ data.VALUEREMAIN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                              </td>
                  
                              <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                {{ data.ALLBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.TOTALBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.REMAIN | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.REMAIN | formatNumberLocal }}
                                </span>
                               
                              </td> 
                              <td class="has-text-right">  
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.SELLPRICE | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.SELLPRICE | formatNumberLocal }}
                                </span>
                              </td> 
                              <td class="has-text-right">
                               
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.REMAIN*data.SELLPRICE | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.REMAIN*data.SELLPRICE | formatNumberLocal }}
                                </span>
                              </td> 

                                                            
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="4" class="has-text-centered">
                                ລວມ
                                {{ productInStockUsage.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["SELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["OFFICESELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["BROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["ALLBROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                            </tr>
                          </tfoot>
                          
                        </table>

                        <div style="font-size: 18px; font-weight: bold; margin-top: 30px;">
                          ລໍຖ້າອະນຸມັດ
                        </div>

                        <table class="table is-fullwidth is-narrow is-small" style="background-color: #f2e5b1;"> 
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">
                                # 
                                
                              </th>

                              <th class="has-text-left " width="10%">
                                ວັນທີ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເຄື່ອງໃນສາງ
                              </th>
                              <th class="has-text-right " width="8%">
                              ຂາຍອອກ
                              </th>  
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ  <br>
                                ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ 
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ລວມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ<br>ສະສົມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຈຳນວນ<br>ຍັງເຫຼືອ
                              </th>
                             
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productInStockOutWait"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}
                                <b-button 
                                    class="is-small btn-group-margin"
                                    type="is-danger"
                                    size="is-small"
                                    @click="cancelProductStockUsage(data.ID)"        
                                >X
                                </b-button>
                              </td>

                              <td class="has-text-left">
                                {{data.TXDATE}}
                              </td>
                              <td class="has-text-right">
                                {{  data.INSTOCK | formatNumberLocal }}
                              </td>   
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                              </td>
                  
                              <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                {{ data.ALLBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.TOTALBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.REMAIN | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.REMAIN | formatNumberLocal }}
                                </span>
                               
                              </td> 
                                                            
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="3" class="has-text-centered">
                                ລວມ
                                {{ productInStockOutWait.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["SELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["OFFICESELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["BROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["ALLBROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                            </tr>
                          </tfoot>
                          
                        </table>
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="ຕິດຕາມເຄື່ອງອອກສາງ (ປະຈຳວັນ)">
              <div class="columns scrollme">
                <div class="column">
                  <b-field>
                    <div class="columns" style=" display: flex; min-height: 800px;" >
                      
                      <div class="column column">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ປະຫວັດ ການເບີກເຄື່ອງອອກສາງ (ປະຈຳວັນ)</div>    
                        <div class="columns">
                          <div class="column">  
                            ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="productStockOutTxdate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                          <div class="column">
                            <b-button style=" margin-top: 23px;"
                                class="btn-group-margin"
                                type="is-primary"
                                @click="getProductStockOutHistory()"        
                            >ເບິ່ງຂໍ້ມູນ
                            </b-button>
                            

                          </div>
                        </div> 
                     
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">
                                # 
                                
                              </th>
                             
                              <th class="has-text-left " width="25%">
                                ສິນຄ້າ
                              </th>
                                
                              <th class="has-text-right " width="7%">
                                ໃນ<br>ສາງ(1)
                              </th>
                              <th class="has-text-right " width="7%">
                                ຫ້ອງການ<br>ລໍຖ້າ
                              </th>
                              <th class="has-text-right " width="7%">
                                ເສຍຫາຍ<br>ລໍຖ້າ
                              </th>
                              <th class="has-text-right " width="7%">
                                ຂາຍອອກ<br>ລໍຖ້າ
                              </th>
                              <th class="has-text-right " width="7%"> 
                                ຂາຍອອກ<br>ທັງໝົດ
                              </th>
                              <th class="has-text-right " width="7%">
                                ໃນ<br>ສາງ(2)
                              </th>
                              <!-- <th class="has-text-right " width="7%">
                                ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="7%">
                                ເສຍຫາຍ 
                              </th>
                              <th class="has-text-right " width="7%">
                                ຂາຍອອກ
                              </th> -->
                              
                              <th class="has-text-centered " width="10%">
                                ຈັດການ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productStockOutHistory"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}
                              </td>

                             
                              <td class="has-text-left">
                               <span style="color:red"> {{ data.LOTID }}  </span> {{  data.PRODUCTNAME }}
                              </td>   
                              <td class="has-text-right" style="font-weight: bold;">
                                {{ data.LOTREMAIN | formatNumberLocal }}
                              </td>               
                              <td class="has-text-right" style="color: orangered;">
                                {{ data.OFFICESELL_WAIT | formatNumberLocal }}
                              </td>
                              <td class="has-text-right" style="color: orangered;">
                                {{ data.BROKEN_WAIT | formatNumberLocal }}
                              </td>
                              <td class="has-text-right" style="color: orangered;">
                                {{ data.SELL_WAIT | formatNumberLocal }}
                              </td>
                              <td class="has-text-right" style="color: red;">
                                  {{ data.TOTALSELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right" style="font-weight: bold;">
                                {{ data.LOTREMAIN - data.OFFICESELL_WAIT - data.BROKEN_WAIT - data.SELL_WAIT  | formatNumberLocal }}
                              </td>  
                              <!-- <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                              </td>

                               -->
                              
                              <td class="has-text-centered">  
                                
                                <b-button v-if="data.CHECKSTATUS == 0"
                                    class="btn-group-margin"
                                    type="is-primary"
                                    @click="checkWaitQuantity(data)"        
                                >ກົດຖືກຕ້ອງ 
                                </b-button> 
                                <span v-else-if="data.CHECKSTATUS==1" style="color: red;">  
                                  ຖືກຕ້ອງ
                                </span>
                                
                              </td> 
                                          
                            </tr>
                          </tbody>
                          
                          
                        </table>
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>

            
          </b-tabs>
    </div>
    <div class="contain print-only page-break">
      <div class="contain">
      
      </div>
    </div>
  </section>
</template>

<script>  
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab:2,

      activeTabSub: 2,

      selectedVender: null,
      stockVenderList: [],

      stockDate: null,
      stockStartDate: null,
      stockEndDate: null,

      stockOutDate: null,

      quantityperpack: 0,
      
      selectedStockProduct: null,
      stockProductSub: [],

      selectedStockProductAmount: 0,
      selectedStockProductTotal: 0,

      stockProductList: [],
      selectedProduct: null,

      stockinHistory: [],
      stockoutHistory: [],

      productInStock: [],
      selectedProductinStock: null ,

      selectedProductOutData: [],
      

      selectedStockProductSell: 0,
      selectedStockProductOfficeSell: 0,
      selectedStockProductBroken: 0,
      isActiveStockOutForm: 0,
      
      productInStockUsage: [],
      productInStockOutWait: [],
      productStockUsageMaxID: null,
      selectedRemainProduct: null,
      stockRemainProductList: [],

      stockStatusList: [
        { ID: 1, NAME: "ຍັງຢູ່ໃນສາງ" },
        { ID: 0, NAME: "ອອກສາງແລ້ວ" },
      ],
      selectedRemainProductStatus: { ID: 1, NAME: "ຍັງຢູ່ໃນສາງ" },

      productSummary: [],

      productStockOutHistory: [],
      productStockOutTxdate: [],

      productStockOutHistoryByProduct: [],
      productStockOutTxdateByProduct: [],

      stockVenderProductList: [],
      selectedStockVender: null,
      selectedStockProductVender: null,

      selectedFProduct: null,
      fProductList: [],

      stockProductRemainDate: null,
      stockProductRemainList: [],
      stockProductRemainSavedList: [],
      isGetStockProductRemain: 0,

      isloadwait: 0 ,

    };
    
    
  },
  methods: {   

    checkWaitQuantity(data){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {
              
              var params = {
                data: data,
                username: this.username,  
              };
              const loadingComponent = this.$loading.open({}); 

             RestAPI.checkWaitQuantity(params) 
               .then(() => {
                loadingComponent.close();
                 this.getProductStockOutHistory(); 
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                loadingComponent.close();
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    saveProductRemainToStock(){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {
              
              var params = {
                data: this.stockProductRemainList,
                username: this.username,  
              };
              

             RestAPI.saveProductRemainToStock(params) 
               .then(() => {
                  this.isGetStockProductRemain = 1;
                  this.getStockProductRemainSaved();
                  
                 
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getStockProductRemain(){
      this.isGetStockProductRemain = 0;
      this.getProductInStockSummaryForOrder();
    },

    getStockProductRemainSaved(){
      this.isGetStockProductRemain = 1;
      RestAPI.getStockProductRemainSaved(this.dateFormatterYYYYMMDD(this.stockProductRemainDate))
      .then((res) => {
        this.stockProductRemainSavedList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },
    
    saveProductToStock(){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {
              this.selectedStockVender = {"ID": this.selectedStockProductVender.ID,"NAME": this.selectedStockProductVender.NAME};   
              
              var params = {
                stockvenderid: this.selectedStockProductVender.ID,
                productid: this.selectedFProduct.ID,
                username: this.username,  
              };
              
              // console.log("params: "+JSON.stringify(params))
             RestAPI.saveProductToStock(params) 
               .then((res) => {
              // console.log("res: "+JSON.stringify(res))    
                  this.getStockVenderProduct();
                  if(res.data == 'duplicate'){
                    this.$swal("ສິນຄ້າຊ້ຳ, ລອງໃໝ່", "", "error");
                    return false;
                  }
                
                
                 this.selectedStockProductVender = null;
                 this.selectedFProduct = null;
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getStockVenderProduct(){
      // console.log("this.selectedVender.ID: " + this.selectedVender.ID)
      RestAPI.getStockVenderProduct(this.selectedStockVender.ID)
      .then((res) => {
        this.stockVenderProductList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });

    },

    getFproductList(){
      // console.log("this.selectedVender.ID: " + this.selectedVender.ID)
      RestAPI.getFproductList()
      .then((res) => {
        this.fProductList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });

    },

    getProductInStockSummaryForOrder() {
      RestAPI.getProductInStockSummaryForOrder()
      .then((res) => {
        this.productSummary = res.data;
        this.stockProductRemainList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getProductInStockSummary() {
      RestAPI.getProductInStockSummary()
      .then((res) => {
        this.productSummary = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    onSelectedStockRemainProduct(type){
      this.isloadwait = type;
      this.getProductinStock();
      // console.log("onSelectedStockRemainProduct")

    },

    cancelProductStockUsage(id){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                id: id,
                username: this.username,  
              };
              
             RestAPI.cancelProductStockOutWait(params) 
               .then(() => {
                   this.getProductinStockUsage();
                  this.getProductinStock();
                  this.getStockHistory();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },   

    cancelProductStockIn(id){ 
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                id: id,
                username: this.username,  
              };
              
             RestAPI.cancelProductStockIn(params) 
               .then(() => {
                  this.getProductinStock();
                  this.getStockHistory();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getProductInStockDetail(data){
      this.activeTab= 1;
      this.selectedProductOutData = data;
      this.isActiveStockOutForm = true;
      this.getProductinStockUsage();
    },

    saveStockOutWait(){ 
      
        if(this.selectedStockProductSell == 0 && this.selectedStockProductOfficeSell==0  && this.selectedStockProductBroken ==0){
          this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
          return false;
        }
        this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ", 
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.stockOutDate),
                stockhistoryid: this.selectedProductOutData.ID,
                sell: this.selectedStockProductSell,
                officesell: this.selectedStockProductOfficeSell,
                broken: this.selectedStockProductBroken,
                productid: this.selectedProductOutData.PRODUCTID,
                username: this.username,  
              };
              
              // console.log("params: "+JSON.stringify(params))
             RestAPI.saveStockOutWait(params) 
               .then((res) => {
                  if(res.data == 'lessthan0'){
                    this.$swal("ເຄື່ອງອອກ ຫຼາຍກວ່າ ເຄື່ອງທີ່ມີໃນສາງ!", "", "error");
                    return false;
                  }

                  this.getProductinStock(); // save
                  this.getRemainProduct(); // save
                  this.getProductStockOutHistory(); // save

                  this.getProductinStockUsage();
                 
                  // this.getProductinStock();
                  // this.getStockHistory();
                  // this.getProductInStockSummary();
                  // this.getProductInStockSummaryForOrder();
                  // this.getRemainProduct();
                  this.selectedStockProductSell = 0;
                  this.selectedStockProductOfficeSell = 0;
                  this.selectedStockProductBroken = 0;
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });

     
    },

    onSelectVender(){
      var venderid=  this.selectedVender.ID

      RestAPI.getStockProductByVender(venderid)
        .then((res) => {
          this.stockProductSub = res.data; 


        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveStockIn(){ 
      if(this.selectedVender== null || this.selectedStockProduct == null || this.selectedStockProductAmount == 0 || this.selectedStockProductTotal== 0){     
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");

      }else{
        this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",  
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.stockDate),
                productid: this.selectedStockProduct.ID,
                quantity: this.selectedStockProductAmount,
                total: this.selectedStockProductTotal,
                venderid: this.selectedVender.ID,
                username: this.username,  
              };

              // console.log("params: "+JSON.stringify(params))  
              
             RestAPI.saveStockIn(params) 
               .then(() => {
                //  this.allProfitStatus();
                  // this.selectedVender = [];
                  // this.stockProductSub = [];
                  this.selectedStockProduct = null;
                  this.selectedStockProductAmount= 0;
                  this.selectedStockProductTotal = 0;
                  

                  this.getStockHistory();
                  this.getProductinStock();
                  this.getStockProductList();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
      }
      
     
    },

    getProductinStockUsage(){// 
      var params = {
            stockhistoryid: this.selectedProductOutData.ID,
            username: this.username,      
          };   
          
         RestAPI.getProductinStockUsage(params) 
          .then((res) => {
             this.productInStockUsage = res.data.list;
             this.productInStockOutWait = res.data.wait;
             this.productStockUsageMaxID = res.data.max.MAXID;

             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getProductStockOutHistory(){// 
      var params = {
            txdate: this.dateFormatterYYYYMMDD(this.productStockOutTxdate),
            username: this.username,      
          };   
          
         RestAPI.getProductStockOutHistory(params) 
          .then((res) => {
             this.productStockOutHistory = res.data.list;

             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getProductStockOutHistoryByProduct(){// 
      var params = {
            txdate: this.dateFormatterYYYYMMDD(this.productStockOutTxdateByProduct),
            username: this.username,      
          };   
          
         RestAPI.getProductStockOutHistoryByProduct(params) 
          .then((res) => {
             this.productStockOutHistoryByProduct = res.data.list;

             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getRemainProduct(){// 
         RestAPI.getRemainProduct() 
          .then((res) => {
             this.stockRemainProductList = res.data;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getProductinStock(){// 
      var params = {
            productid: this.selectedRemainProduct ? this.selectedRemainProduct.ID : 0,
            stockstatus: this.selectedRemainProductStatus.ID,
            isloadwait: this.isloadwait,
            username: this.username,      
          };   
          
         RestAPI.getProductinStock(params) 
          .then((res) => {
             this.productInStock = res.data;
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getStockHistory(type=1){// type= 1 is in, 2 is out
      var params = {
            type: type,
            startdate: this.dateFormatterYYYYMMDD(this.stockStartDate),  
            enddate: this.dateFormatterYYYYMMDD(this.stockEndDate),  
            productid: this.selectedProduct ? this.selectedProduct.ID : 0,
            username: this.username,      
          };   

          // console.log("params: "+ JSON.stringify(params));
          
         RestAPI.getStockHistory(params) 
          .then((res) => {
            // console.log("getStockHistory: " + JSON.stringify(res.data));
            if(type==1){
              this.stockinHistory =  res.data;
            }else{
              this.stockoutHistory =  res.data;
            }
            
            this.stockRemain = res.data.stockRemain;            
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getStockProductList() {
      RestAPI.getStockProductList()
      .then((res) => {
        this.stockProductList = res.data;
        // console.log("getStockProductList: " + JSON.stringify(res.data));
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },


    getStockVenderList() {
      RestAPI.getStockVenderList()
      .then((res) => {
        this.stockVenderList = res.data.stockVenderList;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.currentDate = new Date();

    this.startDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.endDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );

    this.stockDate =  new Date(this.currentDate);
    this.stockStartDate = this.startDate;
    this.stockEndDate = this.endDate;

    this.stockProductRemainDate = new Date(this.currentDate);

    this.stockOutDate =  new Date(this.currentDate);

    this.productStockOutTxdate =  new Date(this.currentDate);
    // this.productStockOutTxdate =  new Date('2025-07-23');   
    this.productStockOutTxdateByProduct =  new Date(this.currentDate);
    
    // this.getStockVenderList();
    // this.getStockProductList(); 
    // this.getStockHistory();
   
    // this.getProductInStockSummary();
    // this.getProductInStockSummaryForOrder();
    this.getProductinStock(); // save
    this.getRemainProduct(); // save
    this.getProductStockOutHistory(); // save
    // this.getProductStockOutHistoryByProduct();
    // this.getFproductList();
    // this.getStockProductRemainSaved();
    

  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 20%;
}
.column-65 {
  flex: 0 0 80%;
}


.column-40 {
  flex: 0 0 35%;
}
.column-60 {
  flex: 0 0 65%;
}

.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
